export default {
  debug: true,

  logReduxActions: true,

  ga: {
    logEnabled: true
  },

  webApi: {
    secure: false,
    host: 'api.apli-alt.local',
    path: '/'
  }
};



// WEBPACK FOOTER //
// ./src/config/env/local.js